export default __webpack_public_path__ + "static/media/promo-you-know-who_02.e1deeb2a.jpg";